import React, { createContext, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

const ChatContext = createContext();

const ChatProvider = ({ children }) => {
  const [selectedChat, setSelectedChat] = useState();
  const [user, setUser] = useState();
  const [notification, setNotification] = useState([]);
  const [chats, setChats] = useState();

  const history = useHistory();

  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    setUser(userInfo);

    if (!userInfo) {
      history.push("/");
      return;
    }

    // подтягиваем свежий профиль (имя, аватар, права) — localStorage может устареть
    axios
      .get("/api/user/me", {
        headers: { Authorization: `Bearer ${userInfo.token}` },
      })
      .then(({ data }) => {
        const fresh = { ...userInfo, ...data };
        setUser(fresh);
        localStorage.setItem("userInfo", JSON.stringify(fresh));
      })
      .catch((error) => {
        if (error.response?.status === 401) {
          localStorage.removeItem("userInfo");
          setUser(undefined);
          history.push("/");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <ChatContext.Provider
      value={{
        selectedChat,
        setSelectedChat,
        user,
        setUser,
        notification,
        setNotification,
        chats,
        setChats,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};

export const ChatState = () => {
  return useContext(ChatContext);
};

export default ChatProvider;
